<template>
	<div id='findRevenueExpense' >
		<div class='public-content'>
			<div class="profitStatement_top clearfix">
				<el-form :inline='true' class='fl'>
					<el-form-item label='日期筛选'>
						<template v-if='isShowQuarter'>
							<accounting-period @defaultTime='defaultTime' :isDaterange='false'></accounting-period>
						</template>
					</el-form-item>
					<el-form-item>
						<el-button size="mini" class='minButton' @click='handlerClickSearch'>
							搜索
						</el-button>
					</el-form-item>
				</el-form>
				<div class="fr">
					<print-operation
						:formData="printForm"
						:showContinuit="false"
					></print-operation>
					<el-button size="mini" @click="handleDownload">
						导出
					</el-button>
				</div>
			</div>
			<public-table :table='tableData'>
				<template slot-scope="props" slot="name">
					<a href="javascript:;" v-text="props.scope.row.name" @click="handlerClick(props.scope.row)" v-if='props.scope.row.style!=4'></a>
					<span v-else v-text="props.scope.row.name"></span>
				</template>
			</public-table>
		</div>
		<balance-sheet-dialog
			:dialogVisible.sync="isShowReport"
			:data="reportDialogData"
			@onRefresh='onRefresh'
			:showRegulation="true">
		</balance-sheet-dialog>
	</div>
</template>
<script>
	import publicTable from '@/components/publicTable'
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import {currencys} from '@/assets/utils/currencyFormat'
	import balanceSheetDialog from '@/components/dialog/balanceSheetDialog'
	import printOperation from '@/components/print'
	export default {
		components: {
			publicTable,
			accountingPeriod,
			balanceSheetDialog,
			printOperation

		},
		data() {
			return {
				isFirstActive: false,
				printForm: {        // 打印参数
					data: {
						quarter: '',
						yearPeriods: '',
					},
					url: '/createPDF/printBudget',
					continuityUrl: '/createPDF/printBudget'
				},
				firstGet: true,          // 第一次进页面请求一次
				isShowReport: false,          // 弹框显示
				reportDialogData: {	// 弹窗参数
					reportId: '',
					yearPeriods: '',
					style: ''
				},
				pickerBeginDateBefore: {
					disabledDate: (time) => {
						let beginStartDateVal = this.date.start;
						let beginEndDateVal = this.date.end;

						if (beginEndDateVal && beginEndDateVal) {
							return time.getTime() > beginEndDateVal || time.getTime() < beginStartDateVal
						}
					}
				},
				select: {			// 选择框数据
					reportVal: '1',
					quarterVal: '_1'
				},
				form: {			// 筛选条件
					yearPeriods: '',
					quarter: ''
				},
				date: {			// 日期控件参数
					start: '',
					end: '',
					nowYearPeriods: ''
				},
				value: '',
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '项目',
						value: 'name',
						show: 'template'
					},{
						label: '行次',
						value: 'sort',
						width: 80,
						show: 'normal'
					},{
						label: '本年金额',
						value: 'countYearNumber',
						formatter: this.formatter,
						show: 'normal'
					},{
						label: '年初金额',
						value: 'beginYearNumber',
						formatter: this.formatter,
						show: 'normal'
					}],
					operation: {
						label: '操作',
						value: 'operation',
						data: []
					},
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},
			}
		},
		created() {
			
		},
		computed: {
			// 是否显示季报
			isShowQuarter () {
				this.form = Object.assign({}, this.form, {
					quarter: this.select.reportVal != '1' ? this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyy') + this.select.quarterVal : '',
					yearPeriods: this.select.reportVal == '1' ? (this.form.yearPeriods ? this.form.yearPeriods : this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyyMM')) : ''
				})

				this.$set(this.printForm, 'data', {
					yearPeriods: this.form.yearPeriods,
					quarter: this.form.quarter
				})

				return true;
			},
			 getClickCache() {
		        return this.$store.state.loadstatus.isClickCache;
		      }
		},
	    activated() {
	      if(this.getClickCache&&this.isFirstActive) {
	        this.handlerClickSearch()
	      }
	      this.isFirstActive = true;
	    },
		methods: {
			// 表格格式化
			formatter(row, column, cellValue, index) {
				if(!row[column.property]) {
					return "";
				}else {
					return currencys(row[column.property]);
				}
			},
			// 导出
			handleDownload (){
				const params = {
					cid: sessionStorage.cid,
					token: sessionStorage.token,
					yearPeriods: this.form.yearPeriods,
					quarter: this.form.quarter
				}

				const router = this.$router.resolve({
					path: '/reportform/exportBudget',
					query: params
				})

				window.open(this.$rootUrl + router.href, '_blank');
			},
			// 显示弹窗
			handlerClick (row) {
				this.reportDialogData = Object.assign({}, this.reportDialogData, {
					reportId: row.id,
					yearPeriods: this.form.yearPeriods,
					style: row.style,
					quarter:this.form.quarter
				})
				this.isShowReport = true;
			},
			// 搜索/获取表格数据
			handlerClickSearch() {
				try {
					this.tableData.loading = true;
					this.$http.post('reportform/findAllBudget' , this.form).then(res=>{
						console.log(res)
						this.tableData.loading = false;
						if(res) {
							this.tableData.data = res.data.data;
							this.tableData.data.forEach(item=>{
								for (const i in item) {
									if (typeof item[i] === 'number') {
										item[i] = item[i] == 0 ? '' : item[i];
									}
								}
							})
						}
					})
				}catch(e) {
					this.tableData.loading = false;

				}
			},
			// 重载
			onRefresh(data){
				data&&this.handlerClickSearch();
			},
			// 选择期数
			handleYearChange (val) {
				this.$set(this.form, 'quarter', this.$util.formatDate.format(val, 'yyyy')+this.select.quarterVal);
				this.$set(this.printForm.data, 'quarter', this.form.quarter)
			},
			// 接收会计期间数据
			defaultTime(data) {
				this.form = Object.assign(this.form,{
					yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				})
				this.date = Object.assign({}, this.date, {
					start: data.defaultStartDate,
					end: data.defaultEndDate,
					nowYearPeriods: data.yearPeriodsStart
				})
				if(this.firstGet) {
					this.handlerClickSearch();
					this.firstGet = false;
				}
			},
		},
		mounted() {

		}
	}
</script>
<style lang='less' scoped>
	#findRevenueExpense {
		
	}
	
</style>


// WEBPACK FOOTER //
// src/pages/reportForm/findRevenueExpense.vue